import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "placeholder", "aria-describedby", "aria-invalid"]
const _hoisted_3 = {
  key: 0,
  class: "input-element__label"
}
const _hoisted_4 = ["id"]


import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicTextInput',
  props: {
    placeholder: {},
    id: {},
    name: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const { value, errorMessage } = useField(() => props.name);

const onInput = () => {
  emit('update:modelValue', value.value as string);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-element", _unref(value) ? 'not-empty' : ''])
  }, [
    _createElementVNode("label", { for: _ctx.id }, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        type: "text",
        name: _ctx.name,
        placeholder: _ctx.placeholder,
        "aria-describedby": _unref(errorMessage) ? `${_ctx.id}-error` : null,
        "aria-invalid": _unref(errorMessage) ? true : null,
        onInput: onInput
      }, null, 40, _hoisted_2), [
        [_vModelText, _unref(value)]
      ]),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        id: `${_ctx.id}-error`,
        class: "error",
        "aria-live": "assertive",
        role: "alert"
      }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_4)
    ], 8, _hoisted_1)
  ], 2))
}
}

})